import { Link, List, ListItem, useTheme } from "@mui/material";
import { socials } from "@/utils/staticData/contacts";
import {getSocialsFooterStyles, getSocialsStyles} from "./styles";

interface SocialProps {
    isVisableColor?: boolean;
}
  const Socials = ({ isVisableColor } : SocialProps) => {
  const theme = useTheme();

  return (
    <List sx={{ display: "flex", gap: { xs: 2, lg: 3 } }} disablePadding>
      {socials.map(({ Icon, href, label }) => (
        <ListItem key={href} sx={{ maxWidth: "fit-content" }} disablePadding>
          <Link
            target="_blank"
            rel="noreferrer"
            aria-label={label}
            href={href}
            color={theme.palette.grey[600]}
            sx={isVisableColor ? getSocialsFooterStyles() : getSocialsStyles(theme)}
          >
            <Icon />
          </Link>
        </ListItem>
      ))}
    </List>
  );
};

export default Socials;
